import React, { Component } from "react";
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';
import { Segment } from "semantic-ui-react";
class Details extends Component {
  constructor(props) {
    super(props);
    let details = this.props.details;
    this.state = {
      details : details,
      isLoading: false,
      xhrResponse: {
        success: null,
        message: ""
      }
    };
  }

    formatDetail(detail) {
      try {
        return Object.entries(detail).map(([key, value]) => (
          <div key={key}>
            <b>{key}:</b> {value}
          </div>
        ));
      } catch (e) {
        console.error(e);
        return ''; // Handle errors by returning an empty string or some default value
      }
    }

  render() {
    const {
      details,
      isLoading
    } = this.props;

    // Convert details into an array of objects suitable for ReactTable
    const detailData = details.map(detail => ({ jsonString: this.formatDetail(detail) })).reverse();

    const columns = [
      {
        Header: 'Details',
        accessor: 'jsonString', 
        Cell: props => <div style={{ textAlign: "center" }}>{props.value}</div> 
      }
    ];

    return (
      <ReactTable
        data={detailData}
        columns={columns}
        className="-striped -highlight"
        loading={isLoading} 
        resizable
        defaultPageSize={10}
        minRows={0}
        showPagination={false}
      />
    );
  }
}


export default Details;
